<div class="profile-selection-modal" [class.is-loading]="loading()">
  <button
    type="button"
    class="close-button"
    [attr.aria-label]="closeLabel()"
    (click)="closeModal()"
    [disabled]="loading()"
    data-cy="close-modal-button">
    <lkt-icon name="close" [size]="null" />
  </button>

  <div class="modal-header">
    <span class="user-icon" data-cy="user-profile-icon">
      <lkt-icon name="user" [size]="null" />
    </span>

    <h2 class="modal-title" id="profile-selection-modal-title" data-cy="modal-title">
      {{ title() }}
    </h2>
  </div>

  <div class="profile-options" role="group" aria-labelledby="profile-selection-modal-title">
    @for (profile of profiles(); track profile.id) {
      <button
        class="profile-option"
        type="button"
        [disabled]="loading()"
        [attr.data-cy]="profile.role + '-profile-option'"
        (click)="selectProfile(profile)">
        <span class="option-icon">
          @if (profile.svgIcon) {
            <lkt-icon [name]="profile.svgIcon" [size]="null" />
          } @else {
            <i [class]="profile.icon"></i>
          }
        </span>

        <span class="option-content">
          <span class="option-title">{{ profile.label }}</span>
          @if (profile.subtitle) {
            <span class="option-subtitle">{{ profile.subtitle }}</span>
          }
        </span>

        <span class="option-arrow">
          @if (loading()) {
            <i class="uil uil-spinner spinner" data-cy="profile-loading-spinner"></i>
          } @else {
            <lkt-icon name="chevron-right" [size]="null" />
          }
        </span>
      </button>
    }
  </div>
</div>
